<template>
      <v-btn class="icon-btn mr-2" depressed small @click="switchMode">
        <v-icon class="mr-1">
        mdi-eye
      </v-icon>
        {{ btnCaption }}
        <specialModeStyle v-if="isSpecialMode"></specialModeStyle>
      </v-btn>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SpecialModeView',

  components: {
    specialModeStyle: () => import(
      '@/components/base/SpecialModeStyle'
    )
  },

  data: () => ({
    //btnCaption: 'Версия для слабовидящих'
  }),

  computed: {
    ...mapGetters({
      isSpecialMode: 'user/specialMode',
    }),
    btnCaption: function() {
      if (this.isSpecialMode) return 'Обычная версия'
      return 'Для слабовидящих'
    }
  },

  watch:{
      $route (to, from){
            //this.changeStyles()
      }
    },

  methods: {
    switchMode: function() {
      this.$store.dispatch('user/setSpecialMode', !this.isSpecialMode)
      if (!this.isSpecialMode) this.$router.go()
    }
  }

}

</script>
<style scoped>

/*
html {
  font-size: 150%!important;
}

td {
  font-size: 120%!important;
}

.v-application {
  font-size: 90%!important;
  line-height: 40px;
}

.v-application p{
  font-size: 90%!important;
  line-height: 40px;
}

.v-banner__text {
  line-height: 40px;
}

.v-alert {
  font-size: 90%!important;
}
.help-text>p {
  font-size: 110%!important;
}

.v-data-table th {
  font-size: 110%!important;
}

.v-text-field {
  font-size: 110%!important;
}

.v-tab {
  font-size: 110%!important;
}

*/

.icon-btn {
  color: grey;
}

.user-icon {
  color: #FFB74D;
  font-size: 70pt;
}

</style>
<style>
  .special-mode-90 {
    font-size: 90%!important;
    line-height: 40px;
  }
  .special-mode-110 {
    font-size: 110%!important;
  }
  .special-mode-150 {
    font-size: 150%!important;
  }
</style>
